<modal-hoc
    [modalTheme]="modalTheme"
    [modalTitle]="title"
    [submitButton]="false"
    [cancelButton]="false"
    (modalCancel)="onModalCancel($event)">
    @if (loadingCategories) {
        <fdx-spinner />
    } @else {
        <div class="fdx-category-option d-flex flex-column gap-2">
            @for (category of categories; track category) {
                @if (amazonCategoryType && $first && category[0].value) {
                    <div class="fdx-category-name-amazon">{{ category[0].value }}</div>
                }
                <fdx-category-paths
                    [categoryPaths]="category"
                    [itemTypeText]="filterByProductType && category[0].meta?.itemType ? category[0].meta?.itemType : null"
                    [amazonCategoryType]="amazonCategoryType"/>
            }
        </div>
    }
</modal-hoc>
